"use strict"; // https://drafts.csswg.org/cssom-view-1/#the-screen-interface

var _classCallCheck = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/classCallCheck");

var ScreenImpl = function ScreenImpl() {
  _classCallCheck(this, ScreenImpl);
};

ScreenImpl.prototype.availWidth = 0;
ScreenImpl.prototype.availHeight = 0;
ScreenImpl.prototype.width = 0;
ScreenImpl.prototype.height = 0;
ScreenImpl.prototype.colorDepth = 24;
ScreenImpl.prototype.pixelDepth = 24;
exports.implementation = ScreenImpl;